import type { ReactNode } from "react";
import { cx } from "./cx";

export interface SegmentedOption<V extends string = string> {
  value: V;
  label: ReactNode;
  /** 悬停提示；label 不是文字（只有图标）时同时作为选项的名称，此时必填。label 是文字时名称就是文字本身，不被 title 覆盖。 */
  title?: string;
}

/** 同一组视图参数的互斥切换，二到五个选项，切换立即生效（设计系统 Segmented）。筛选条件用 Select、DateRange，大块视图用 Tabs。选项可以只放图标，名称写在 title（D200 的主题切换）。 */
export function Segmented<V extends string>({ options, value, onChange, label }: { options: SegmentedOption<V>[]; value: V; onChange: (v: V) => void; label: string }) {
  return (
    <div className="ax-segmented" role="group" aria-label={label}>
      {options.map((o) => (
        <button key={o.value} type="button" title={o.title} aria-label={typeof o.label === "string" ? undefined : o.title} aria-pressed={o.value === value} className={cx("ax-segmented-item", o.value === value && "is-active")} onClick={() => onChange(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
